import { MARK_FULL_D, MARK_VIEW_BOX } from "./novariMarkPath";

interface NovariMarkProps {
  size?: number;
  /** Any CSS color; defaults to the theme accent (Ember). */
  color?: string;
  className?: string;
}

/**
 * The Novari mark — the brand's "S" glyph, standalone (no wordmark). Pure
 * SVG vector, so it stays crisp at any size and recolors with the active
 * theme. This is the mark used anywhere the brand icon appears without the
 * "Novari" wordmark next to it: the sidebar, the favicon, loading states.
 *
 * For the drawing/animated version, see NovariMarkLoader.
 */
export default function NovariMark({
  size = 40,
  color = "var(--accent-primary)",
  className,
}: NovariMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={MARK_VIEW_BOX}
      fill="none"
      className={className}
      aria-hidden
    >
      <path d={MARK_FULL_D} fill={color} />
    </svg>
  );
}
